import React from 'react'
import { Route, Routes, } from 'react-router-dom'
import { ThemeProvider, createTheme } from '@mui/material/styles';
import Login from '../admin-login/SignIn';
import Dashboard from './Dashboard';
import User from './User';
import AppBars from './AppBars';
import Homescreen from './Homescreen';
import SendNotifications from './SendNotifications';
import SignUp from '../admin-login/SingUp';
import ForgotPassword from '../admin-login/ForgotPassword';
import TodayActiveUsers from '../dashboardpages/TodayActiveUsers';
import ActiveUsers from '../dashboardpages/ActiveUsers';
import InActiveUsers from '../dashboardpages/InActiveUsers';
import NotificationsConfig from './NotifcationsConfig';
import PrivacyEditor from './PrivacyEditor';
import TermAndCondition from '../pages/TermsAndConditions';
import PrivacyAndPolicy from '../pages/PrivacyAndPolicy';
import HelpAndSupport from '../pages/HelpAndSupport';
import Eula from '../pages/Eula';
import PremiumUsers from '../dashboardpages/PremiumUsers';

const themeOptions = {
  palette: {
    type: 'light',
    primary: {
      main: '#ff3300fa',
    },
    secondary: {
      main: 'rgb(0, 0, 0)',
    },
  },
};

export default function AppRoute() {
  const theme = createTheme(themeOptions);
  return (
    <ThemeProvider theme={theme}>
    <Routes>
        <Route path="/cms" exact Component={Login}/>
        <Route path ='/cms/dashboard' element={<Dashboard/>}/>
        <Route path='/cms/userpage' element ={<User/>}/>
        <Route path='/cms/homescreen' element ={<Homescreen/>}/>
        <Route path='/cms/appbar' element={<AppBars/>}/>
        <Route path='/cms/sendnotifications' element={<SendNotifications/>}/>
        <Route path='/cms/signup' element={<SignUp/>}/>
        <Route path='/cms/forgotpassword' element={<ForgotPassword/>}/>
        <Route path='/cms/todayactiveusers' element={<TodayActiveUsers/>}/>
        <Route path='/cms/activeusers' element={<ActiveUsers/>}/>
        <Route path='/cms/inactiveusers' element={<InActiveUsers/>}/>
        <Route path='/cms/premiumusers' element={<PremiumUsers/>}/>
        <Route path='/cms/notificationsconfig' element={<NotificationsConfig/>}/>
        <Route path='/cms/editorwindow' element={<PrivacyEditor/>}/>
        <Route path='/cms/terms_condition' element={<TermAndCondition/>}/>
        <Route path='/cms/privacy_policy' element={<PrivacyAndPolicy/>}/>
        <Route path='/cms/help_support' element={<HelpAndSupport/>}/>
        <Route path='/cms/eula' element={<Eula/>}/>
    </Routes>
    </ThemeProvider>
  )
}
